import React from 'react';

import Spinner from './spinner';

const FullScreenGlassLoading = props => (
  <div className="full_screen_glass_loading"><Spinner/></div>
);

export default FullScreenGlassLoading;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/fullScreenGlassLoading.jsx